/* BaseBlocks homepage (/) -- shared same-page anchor behaviour for all
   bb-homepage-* sections. Loaded once from index.liquid. */
/* Same-page anchor resolver: hero buttons and category tiles use plain
   fragments (#shop-by-training, #best, #air, #gsp). Each breakpoint's real
   section id is prefixed (d-/m-) to avoid duplicate ids now that both
   variants are simultaneously in the DOM (shown/hidden by CSS only, per
   spec). This resolves a plain hash to whichever prefixed section is
   currently visible and scrolls to it. */
(function () {
  var SECTION_IDS = ['shop-by-training', 'best', 'air', 'gsp'];

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function resolveTarget(name) {
    var d = document.getElementById('d-' + name);
    var m = document.getElementById('m-' + name);
    if (isVisible(d)) return d;
    if (isVisible(m)) return m;
    return d || m || null;
  }

  function handleHash() {
    var name = (location.hash || '').replace('#', '');
    if (SECTION_IDS.indexOf(name) === -1) return;
    var target = resolveTarget(name);
    if (target) target.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href^="#"]');
    if (!a) return;
    var name = a.getAttribute('href').slice(1);
    if (SECTION_IDS.indexOf(name) === -1) return;
    var target = resolveTarget(name);
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + name);
    }
  });

  window.addEventListener('hashchange', handleHash);
  if (location.hash) {
    window.addEventListener('load', function () { setTimeout(handleHash, 0); });
  }
})();

